function getDefaultState() {
    return {
        fornecedor: '',
        fornecedor_total_itens_compra:'',
        fornecedor_total_itens:'',
        fornecedor_total_itens_transito:'',
        fornecedor_total_itens_sobencomenda:'',
        comprador:'',
        config: {}
    };
}

const state = getDefaultState();

const getters = {
    getFornecedor(state) {
        return state.fornecedor;
    },
    getComprador(state) {
        return state.comprador;
    },
    getItensCompra(state) {
        return state.fornecedor_total_itens_compra;
    },
    getItensForn(state) {
        return state.fornecedor_total_itens;
    },
    getItensTransito(state) {
        return state.fornecedor_total_itens_transito;
    },
    getAnaliseTendencia(state) {
        return state.analiseTendencia;
    },
    getConfig(state) {
        return state.config;
    }
};

const mutations = {
    setComprador(state, val) {
        state.comprador = val;
    },
    setFornecedor(state, fornecedor) {
        state.fornecedor = fornecedor;
    },
    setItensCompra(state, val) {
        state.fornecedor_total_itens_compra = val;
    },
    setItensForn(state, val) {
        state.fornecedor_total_itens = val;
    },
    setItensTransito(state, val) {
        state.fornecedor_total_itens_transito = val;
    },
    setItensSobEncomenda(state, val) {
        state.fornecedor_total_itens_sobencomenda = val;
    },
    setConfig(state, val) {
        state.config = val;
    }
};

const actions = {
    setComprador: ({commit}, val) => {
        commit('setComprador', val);
    },
    setFornecedor: ({commit}, fornecedor) => {
        commit('setFornecedor', fornecedor);
    },
    setItensCompra: ({commit}, val) => {
        commit('setItensCompra', val);
    },
    setItensForn: ({commit}, val) => {
        commit('setItensForn', val);
    },
    setItensTransito: ({commit}, val) => {
        commit('setItensTransito', val);
    },
    setItensSobEncomenda: ({commit}, val) => {
        commit('setItensSobEncomenda', val);
    },
    setConfig: ({commit}, val) => {
      commit('setConfig', val);
    }
};

export default {namespaced: true, state, mutations, getters, actions};

